module.exports = __webpack_public_path__ + "img/album04_01.03a47242.jpg";